import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Column, Button, Icon, AnimateIcon } from "../../components";
import { useMatch } from "react-router-dom";
import "./Slider.scss";

export const Slider = ({
  children,
  icon,
  title,
  description,
  serviceName,
  ...otherProps
}) => {
  const intl = useIntl();

  return (
    <div className="slider" {...otherProps}>
      <Column customClass="top">
        <div className="left">
          {icon && (
            <div className="service">
              <div className="icon">
                <AnimateIcon json={icon} />
              </div>
              <div className="service-name">{serviceName}</div>
            </div>
          )}
          <h2 className={`title ${!icon ? "no-icon" : ""}`}>{title}</h2>
        </div>
        <div className="right">
          <h3 className="description">{description}</h3>
          <div>
            <a
              className="button-contact"
              href="https://dashboard.etpay.com/sign-up"
            >
              {intl.formatMessage({ id: "home.banner.slider1.btn.contact" })}{" "}
              <Icon name={"Icon_After"} />
            </a>
          </div>
        </div>
      </Column>

      <Column customClass="bottom column-use-cases" marginCustom={"0px"}>
        {children}
      </Column>
    </div>
  );
};
